import zone from './zone';
import products from './products';

export default {
  namespaced: true,
  modules: {
    zone,
    products,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/zones/index.js